import {Component, OnInit,DoCheck } from '@angular/core';
import { Location } from '@angular/common';
import {Router,ActivatedRoute} from '@angular/router';
import {DashboardService} from '../../services/events/dashboard.service';
import {environment} from '../../../environments/environment';
import {StorageManager} from '../../common/storage-manager.class';
import {LoginApiService} from '../../services/api/login-api.service';
import { CategoriaService } from 'src/app/services/categorias/categoria';
import { Subscription } from 'rxjs';
import { MessageService } from 'primeng/api';
import {MenuItem} from 'primeng/api';
import { ImageBaseService } from 'src/app/services/imagenes/imagenes.service';
import { url } from 'src/app/config/config';
import { logo, logoDasboard } from 'src/app/config/imagenes';
import { TitleHeaderService } from 'src/app/services/title-header/title.header.service';



@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
    providers:[CategoriaService,MessageService]
})
export class DashboardComponent implements OnInit,DoCheck{

    public version: string = '28.7.9';
    
    public items: MenuItem[];

    ngDoCheck(): void {
        this.dashboardEvent.revisarMenu();
        this.showImage();
        this.titleAnexo = this.location.path().replace("/dashboard/","");
        this.titleAnexo = this.capitalize(this.titleAnexo);
    }
     capitalize(string) {
        return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
    }
    public expression = false;
    public displayImage = false;
    public contador = 0;
    public cols:any[] = [];
    public resultado:any[] = [];
    public registros:any;
    public click:Subscription;
    public es: any;
    public categoria = "";
    public date:Date = new Date();
    public fechaCadena="";
    public displayAnexo=false;
    public titleAnexo="";
    public dispplayContent=false;
    public sidebarMaxWidth: number = 100;
    public isSidebarOpen: boolean = false;
    public clientHeaderDialog: string;
    public showClientDialog: boolean = false;
    //public logoUrl: string = environment.logoUrl;
    public isOnline: boolean;
    public logo: string = '';
    public popupItems = [
        /*
        {
            label: this.loginApi.getCurrentUser().nombre,
            icon: 'fa fa-user'
        },        
        {separator: true},
        */
        {
            label: 'Cerrar Sesión',
            icon: 'fa fa-sign-out',
            command: (): void => {
                StorageManager.deleteUser();
                localStorage.clear();
                this.router.navigate(['login']);
            }
        },
        {
            label: 'Ver ' + this.version,
        }
    ];
    
    public user = StorageManager.getUser() || {} as any;

    public clientes = {
        selected: null,
        filtered: [{label: 'Cargando...', value: null}],
        values: []
    };

    public header: {
        title: string;
        subtitle: string;
    } = {title: 'POMELOS MBC', subtitle: ''};

    public static createNavigation(router: Router) {
        router.navigate(['dashboard']);
    }

    constructor(private router: Router,                
                public dashboardEvent: DashboardService,
                private route: ActivatedRoute,
                private location:Location,
                private categoriaService:CategoriaService,
                private messageService:MessageService,
                private ImageBaseService: ImageBaseService,
                private titleHeaderService: TitleHeaderService
                
                ) {
                    this.showMySideBar();
                    this.titleHeaderService.changeHeaderTitle().subscribe((rutas) => {
                        // console.log('rutas', rutas);
                 
                        if (rutas.titulo != null && rutas.titulo.length > 1) {
                            this.dashboardEvent.headerTitle = rutas.titulo;
                            localStorage.setItem('id_documento_registro', rutas.id);
                             // console.log('rutas', rutas);
                        } else {
                            if (this.dashboardEvent.headerTitle == null || this.dashboardEvent.headerTitle.length == 0) {
                                this.dashboardEvent.headerTitle = "Pomelos MBC";
                            } else {
            
                            }
            
                        }
            
                    });
                    
                    
    }
    public menuItems(){
        this.items = [
            
            {
                label: 'Revisiones',
                icon: 'pi pi-fw pi-file',
                command: (): void => {
                    this.titleAnexo=this.location.path().replace("/dashboard/","");
                    let contarRutas=this.titleAnexo.split("/");
                    this.displayAnexo=false;
                    if(contarRutas.length!=1){
                        this.messageService.add({severity:'info', summary: 'Info', detail:'Tiene que estar en un documento para poder ver las revisiones'});

                    }else{
                        this.displayAnexo=true;
                    }
                 
              }
            },
            { 
                label: 'Cerrar Sesión',
            icon: 'fa fa-sign-out',
            command: (): void => {
                StorageManager.deleteUser();
                localStorage.clear();
                this.router.navigate(['login']);
            }
            },
            {
                label: 'Ver ' + this.version,
            }
        ];
    }
    public menuItemsUser() {
        this.items = [
            
            {
                label: 'Usuarios',
                    icon: 'fa fa-user',
                    command: (): void => {
                        this.dashboardEvent.headerTitle="Control de usuarios";
                      this.router.navigate(['dashboard/usuarios']);
                      if(this.isSidebarOpen){
                        this.isSidebarOpen = !this.isSidebarOpen;
                      }
                      
                  }
            },
            {
                label: 'Tablas maestras',
                icon: 'fa fa-file-text',
                items: [
                    {
                        label: 'Variedades', icon: 'pi fa fa-lemon-o', command: (): void => {
                            this.dashboardEvent.headerTitle = "Variedades";
                            this.router.navigate(['dashboard/variedades']);
                            if (this.isSidebarOpen) {
                                this.isSidebarOpen = !this.isSidebarOpen;
                            }

                        }
                    },
                    {
                        label: 'Prod. camión',
                            icon: 'fa fa-product-hunt',
                            command: (): void => {
                                this.dashboardEvent.headerTitle = "Productos camión";
                              this.router.navigate(['dashboard/prod_camion']);
                              if(this.isSidebarOpen){
                                this.isSidebarOpen = !this.isSidebarOpen;
                              }
                              
                          }
                    },
                    {
                        label: 'Paises',
                            icon: 'pi fa fa-map',
                            command: (): void => {
                                this.dashboardEvent.headerTitle="Países";
                              this.router.navigate(['dashboard/paises']);
                              if(this.isSidebarOpen){
                                this.isSidebarOpen = !this.isSidebarOpen;
                              }
                              
                          }
                    },
                    {
                        label: 'Empresas',
                            icon: 'pi fa fa-industry',
                            command: (): void => {
                                this.dashboardEvent.headerTitle="Empresas";
                              this.router.navigate(['dashboard/empresas']);
                              if(this.isSidebarOpen){
                                this.isSidebarOpen = !this.isSidebarOpen;
                              }
                              
                              
                          }
                    },
                    {
                        label: 'Calibre',
                            icon: '',
                            command: (): void => {
                              this.dashboardEvent.headerTitle="Calibre";
                              this.router.navigate(['dashboard/calibre']);
                              if(this.isSidebarOpen){
                                this.isSidebarOpen = !this.isSidebarOpen;
                              }
                              
                          }
                    },
                    {
                        label: 'Tipo de Palet',
                            icon: '',
                            command: (): void => {
                              this.dashboardEvent.headerTitle="Tipo de Palet";
                              this.router.navigate(['dashboard/tipo_palet']);
                              if(this.isSidebarOpen){
                                this.isSidebarOpen = !this.isSidebarOpen;
                              }
                              
                          }
                    },      
                    {
                        label: 'Paletización',
                            icon: '',
                            command: (): void => {
                              this.dashboardEvent.headerTitle="Paletización";
                              this.router.navigate(['dashboard/paletizacion']);
                              if(this.isSidebarOpen){
                                this.isSidebarOpen = !this.isSidebarOpen;
                              }
                              
                          }
                    },            
                    {
                        label: 'Marcas comerciales',
                            icon: '',
                            id:'marcas',
                            command: (): void => {
                              this.dashboardEvent.headerTitle = "Marcas Comerciales";
                              this.router.navigate(['dashboard/marcas-comerciales']);
                              if(this.isSidebarOpen){
                                this.isSidebarOpen = !this.isSidebarOpen;
                              }
                              
                          }
                    },
                    {
                        label: 'Presentación',
                            icon: '',
                            id:'presentacion',
                            command: (): void => {
                              this.dashboardEvent.headerTitle = "Presentación";
                              this.router.navigate(['dashboard/presentacion']);
                              if(this.isSidebarOpen){
                                this.isSidebarOpen = !this.isSidebarOpen;
                              }
                              
                          }
                    },
                    {
                        label: 'Clientes',
                            icon: '',
                            id:'clientes',
                            command: (): void => {
                              this.dashboardEvent.headerTitle = "Clientes";
                              this.router.navigate(['dashboard/clientes']);
                              if(this.isSidebarOpen){
                                this.isSidebarOpen = !this.isSidebarOpen;
                              }
                              
                          }
                    },
                    {
                        label: 'Proveedores',
                            icon: '',
                            id:'proveedores',
                            command: (): void => {
                              this.dashboardEvent.headerTitle = "Proveedores";
                              this.router.navigate(['dashboard/proveedores']);
                              if(this.isSidebarOpen){
                                this.isSidebarOpen = !this.isSidebarOpen;
                              }
                              
                          }
                    },
                    {
                        label: 'Agricultores',
                            icon: '',
                            id:'agricultores',
                            command: (): void => {
                              this.dashboardEvent.headerTitle = "Agricultores";
                              this.router.navigate(['dashboard/agricultores']);
                              if(this.isSidebarOpen){
                                this.isSidebarOpen = !this.isSidebarOpen;
                              }
                              
                          }
                    },
                    {
                        label: 'Cuadrillas',
                            icon: '',
                            id:'cuadrillas',
                            command: (): void => {
                              this.dashboardEvent.headerTitle = "Cuadrillas";
                              this.router.navigate(['dashboard/cuadrillas']);
                              if(this.isSidebarOpen){
                                this.isSidebarOpen = !this.isSidebarOpen;
                              }
                              
                          }
                    },
                    {
                        label: 'Tipo de envase',
                            icon: '',
                            id:'tipo_envase',
                            command: (): void => {
                              this.dashboardEvent.headerTitle = "Tipo de envase";
                              this.router.navigate(['dashboard/tipo_envase']);
                              if(this.isSidebarOpen){
                                this.isSidebarOpen = !this.isSidebarOpen;
                              }
                              
                          }
                    },
                    {
                        label: 'Confección',
                            icon: '',
                            id:'confeccion',
                            command: (): void => {
                              this.dashboardEvent.headerTitle = "Confección";
                              this.router.navigate(['dashboard/confecciones']);
                              if(this.isSidebarOpen){
                                this.isSidebarOpen = !this.isSidebarOpen;
                              }
                              
                          }
                    },
                    {
                        label: 'Códigos EAN',
                            icon: 'fa fa-barcode',
                            id:'ean_articulos',
                            command: (): void => {
                              this.dashboardEvent.headerTitle = "Códigos EAN";
                              this.router.navigate(['dashboard/ean_articulos']);
                              if(this.isSidebarOpen){
                                this.isSidebarOpen = !this.isSidebarOpen;
                              }
                              
                          }
                    },                      
                    {
                        label: 'Transportistas',
                            icon: '',
                            id:'transportistas',
                            command: (): void => {
                              this.dashboardEvent.headerTitle = "Transportistas";
                              this.router.navigate(['dashboard/transportistas']);
                              if(this.isSidebarOpen){
                                this.isSidebarOpen = !this.isSidebarOpen;
                              }
                              
                          }
                    },
                    {
                        label: 'Prod. fitosanitario',
                            icon: 'fa fa-file-text',
                            command: (): void => {
                              this.dashboardEvent.headerTitle="Producto fitosanitario";
                              this.router.navigate(['dashboard/fitosanitario']);
                              if(this.isSidebarOpen){
                                this.isSidebarOpen = !this.isSidebarOpen;
                              }
                              
                          }
                    }, 
                             
                ]
            },
            
            
            {
                label: 'Revisiones',
                icon: 'fa fa-file',
                command: (): void => {
                    
                    if(this.location.path().includes('usuarios')){
                       
                        this.displayImage = true;
                        this.expression = true;
                        this.messageService.add({severity:'info', summary: 'Usuarios', detail:'No disponible en esta sección',life:500});

                    }else{
                      
                        this.titleAnexo=this.location.path().replace("/dashboard/","");
                        let contarRutas=this.titleAnexo.split("/");
                        this.displayAnexo=false;
                        if(contarRutas.length!=1){
                            this.messageService.add({severity:'info', summary: 'Info', detail:'Tiene que estar en un documento para poder ver las revisiones'});

                        }else{
                            this.displayAnexo=true;
                        }
                        
                    }
                  
              }
            },
           
           
           /*  {
                label: 'Idiomas',
                    icon: '',
                    id:'Idiomas',
                    command: (): void => {
                      this.dashboardEvent.headerTitle = "Idiomas";
                      this.router.navigate(['dashboard/idiomas']);
                      if(this.isSidebarOpen){
                        this.isSidebarOpen = !this.isSidebarOpen;
                      }
                      
                  }
            }, */
            
           /*  {
                label: 'Tipo de podrido',
                    icon: '',
                    id:'tipo_podrido',
                    command: (): void => {
                      this.dashboardEvent.headerTitle = "Tipo de podrido";
                      this.router.navigate(['dashboard/tipo_podrido']);
                      if(this.isSidebarOpen){
                        this.isSidebarOpen = !this.isSidebarOpen;
                      }
                      
                  }
            }, */
            
            {
                label: 'Backup',
                    icon: 'fa fa-file-text',
                    command: (): void => {
                      this.dashboardEvent.headerTitle="GENERAR COPIA DE SEGURIDAD";
                      this.router.navigate(['dashboard/documentos']);
                      if(this.isSidebarOpen){
                        this.isSidebarOpen = !this.isSidebarOpen;
                      }
                      
                  }
            },
           
            { 
                label: 'Cerrar Sesión',
            icon: 'fa fa-sign-out',
            command: (): void => {
                StorageManager.deleteUser();
                localStorage.clear();
                this.router.navigate(['login']);
            }
            },
            {
                label: 'Ver ' + this.version,
            }
        ];
    }


    ngOnInit() {
        
        this.ImageBaseService.image64(logoDasboard).toPromise()
        .then( (resp: string) => {
           
            this.logo = resp;
        })

        this.setOnlineService();
        this.showImage();
        
        /* this.fechaSpanish(); */
    }

    private setOnlineService() {
        this.isOnline = navigator.onLine;

        window.addEventListener('online', () => {
            this.isOnline = true;
        });

        window.addEventListener('offline', () => {
            this.isOnline = false;
        });
    }

    public onNavItemClick(id: string) {
       
        this.dashboardEvent.onMenuItemClick(id);
        if ( localStorage.getItem('role').localeCompare('ROLE_ADMIN') != 0 ) {
            this.isSidebarOpen = !this.isSidebarOpen;
          }
          
        //this.isSidebarOpen = !this.isSidebarOpen;
        
    }

    public onSubNavItemClick(id: string) {
        this.dashboardEvent.onSubmenuItemClick(id);
        this.isSidebarOpen = !this.isSidebarOpen;

    }


    public toggleMenu(menu?: any, $event?: any) {
        //menu.toggle($event);
        this.isSidebarOpen = !this.isSidebarOpen;
    }
    public clickItemMenu( $event?: any) {
        //menu.toggle($event);
        this.isSidebarOpen = !this.isSidebarOpen;
    }
    public closeClientDialog() {
        this.showClientDialog = false;
        this.clientHeaderDialog = 'Cambiar cliente';
    }

    public prefsMenu(){
        console.log("Abre preferencias!");
    }

    public exit(){
        StorageManager.deleteUser();
        localStorage.setItem("documentos",null);
        this.dashboardEvent.deleteMenu();
        
        localStorage.clear();
        this.router.navigate(['login']);
    }

    public showImage(){
        this.displayImage=false;
        this.expression=false;
        let contarRutas=this.location.path().split("/");
        //let contarArrayRutas=contarRutas.length;
     
        if(contarRutas.length>2){
            this.displayImage=false;
            this.expression=false;
         
        }else{
            this.displayImage=true;
            this.expression=true;
        }
        
    }
    public showMySideBar(){
       
        
        let contarRutas = this.location.path().split("/");
        //let contarArrayRutas=contarRutas.length;
        
       
        if(contarRutas.length > 2){
          
            this.isSidebarOpen=false;
         
        }else{
            this.isSidebarOpen=true;
        }
        
    }
    restriccionAnexos(){
        this.titleAnexo=this.location.path().replace("/dashboard/","");
        let contarRutas=this.titleAnexo.split("/");
        this.displayAnexo=false;
        if(contarRutas.length!=1){}
    }
    public anexos(menu){
        
        
        this.items=[];
        this.titleAnexo=this.location.path().replace("/dashboard/","");
        let contarRutas=this.titleAnexo.split("/");
        this.displayAnexo=false;
        this.menuItems();
        menu.toggle(event);
        if(localStorage.getItem("role")=="ROLE_ADMIN" ){
            //this.menuItems();
            this.menuItemsUser();
            //menu.toggle(event);
     /*        this.items.push({
                label: 'Usuarios',
                icon: 'pi pi-fw pi-user',
                command: (): void => {
                
                  this.router.navigate(['dashboard/usuarios']);
              }
              
                
            },{ 
                label: 'Cerrar Sesión',
            icon: 'fa fa-sign-out',
            command: (): void => {
                StorageManager.deleteUser();
                this.router.navigate(['login']);
            }
        }); */
        }
        if(this.location.path().includes('usuarios')){
           
           
        }else{
          
            
            if(localStorage.getItem("role")=="ROLE_ADMIN" ){
                //this.menuItems();
                this.menuItemsUser();
                //menu.toggle(event);
         /*        this.items.push({
                    label: 'Usuarios',
                    icon: 'pi pi-fw pi-user',
                    command: (): void => {
                    
                      this.router.navigate(['dashboard/usuarios']);
                  }
                  
                    
                },{ 
                    label: 'Cerrar Sesión',
                icon: 'fa fa-sign-out',
                command: (): void => {
                    StorageManager.deleteUser();
                    this.router.navigate(['login']);
                }
            }); */
            }
            if(contarRutas.length==1 && localStorage.getItem("role")!="ROLE_ADMIN"){
                //this.displayAnexo=true;
                this.categoria=this.titleAnexo;
                
              
               /*  this.items.push({
                    label: 'Anexos',
                    icon: 'pi pi-fw pi-file',
                    command: (): void => {
                    
                      this.displayAnexo=true;
                  }
                }); */
            
             
            }else{
                this.displayAnexo=false;
                if(localStorage.getItem("role")=="ROLE_ADMIN" ){

                }else{
                   // this.displayImage=true;
                   // this.messageService.add({severity:'info', summary: 'Info', detail:'Tiene que estar en un documento para poder ver los anexos'});

                }
            }       
        }
        
        
    }

   
cerrar(){
    this.displayAnexo=false;
}

toDataUrl(url, callback) {
    var xhr = new XMLHttpRequest();
    xhr.onload = function() {
        var reader = new FileReader();
        reader.onloadend = function() {
            callback(reader.result);
        }
        reader.readAsDataURL(xhr.response);
    };
    xhr.open('GET', url);
    xhr.responseType = 'blob';
    xhr.send();
}


}
